import { createStyles } from '@material-ui/core';

import Colours from 'bz-core-controls/styles/colours';

const styles = createStyles({
  pageHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    minHeight: 40
  },
  pageHeaderAccent: {
    background: Colours.lightBlue500,
    flex: '0 0 11px',
    marginRight: 3,
    display: 'flex',
    order: 1,
    height: 40,
    flexFlow: 'column nowrap'
  },
  pageHeaderTitle: {
    order: 2,
    flex: '1 1 auto',
    height: 40,
    display: 'flex',
    flexFlow: 'row nowrap',
    background: Colours.blueGrey900,
    color: 'white',
    fontFamily: 'Montserrat',
    textTransform: 'uppercase',
    alignContent: 'center'
  },
  pageHeaderTitleText: {
    fontSize: 16,
    flex: '1 1 auto',
    alignSelf: 'center'
  },
  pageHeaderTitleIcon: { minWidth: 18, alignSelf: 'center' },
  pageHeaderAdditionalContent: {
    flex: '0 1 auto',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignSelf: 'center',
    alignItems: 'center',
    '&> div': { marginRight: 16 },
    '& a': { marginRight: 16, color: Colours.white, textDecoration: 'underline' }
  }
});

export default styles;
